import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-navy-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-266" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-2xl text-center" data-id="element-267" data-mp="1be0wbuqojvei">
        <p className="font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-268" data-mp="1fgnqi2atpsev">
          Kidney Disease Route™
        </p>
        <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.14em] text-navy-300" data-id="element-269" data-mp="1kep8sl0fdnpa">
          A clinical decision system for physicians
        </p>
        <p className="mt-4 text-[14px] font-semibold text-navy-100 sm:text-[15px]" data-id="element-270" data-mp="nnog7wla6scu">
          Diagnosis. Treatment. Monitoring. Referral.
        </p>
        <p className="mt-5 font-display text-[19px] font-bold italic leading-snug text-brick-300 sm:text-xl" data-id="element-271" data-mp="wpe44sfyf95v">
          Your patient has a kidney problem. Now you have a route.
        </p>

        <p className="mx-auto mt-8 max-w-xl text-[12px] font-medium leading-relaxed text-navy-400" data-id="element-272" data-mp="40gyppwud6uj">
          Kidney Disease Route™ — Educational material for healthcare professionals. It does not
          replace individual clinical judgment, the physician-patient relationship, current clinical
          guidelines, prescribing information, or appropriate specialist consultation.
        </p>
        <p className="mt-4 text-[12px] font-medium text-navy-500" data-id="element-273" data-mp="1u0cygo6b8rb">
          © 2026 Dr. Karito. All rights reserved.
        </p>
      </div>
    </footer>;
}